module.exports = __webpack_public_path__ + "static/media/fujitsu.a9307b93.jpg";